<script lang="ts">
  import { onMount } from 'svelte';
  import { run, showPreferences } from 'vanilla-cookieconsent';
  import 'vanilla-cookieconsent/dist/cookieconsent.css';

  let { showButton = false }: { showButton?: boolean } = $props();

  const config = {
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        autoClear: {
          cookies: [{ name: /^_ga/ }],
        },
        services: {
          ga: {
            label: 'Google Analytics',
            onAccept: () => {},
            onReject: () => {},
          },
        },
      },
      ads: {},
    },
    guiOptions: {
      consentModal: {
        layout: 'box inline' as const,
        position: 'bottom left' as const,
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box' as const,
        equalWeightButtons: true,
        flipButtons: false,
      },
    },
    language: {
      default: 'en' as const,
      autoDetect: 'document' as const,
      translations: {
        en: {
          consentModal: {
            title: 'We use cookies',
            description: '',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            showPreferencesBtn: 'Manage Individual preferences',
            footer: '<a href="https://universalvoice.nl/privacyverklaring/" target="_blank">Privacy Policy</a>',
          },
          preferencesModal: {
            title: 'Manage cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Accept current selection',
            closeIconLabel: 'Close modal',
            serviceCounterLabel: 'Service|Services',
            sections: [
              {
                title: 'Your Privacy Choices',
                description:
                  'In this panel you can express some preferences related to the processing of your personal information.',
              },
              {
                title: 'Strictly Necessary',
                description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Performance and Analytics',
                description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                linkedCategory: 'analytics',
                cookieTable: {},
              },
            ],
          },
        },
        nl: {
          consentModal: {
            title: 'We gebruiken cookies',
            description: '',
            acceptAllBtn: 'Accepteer alles',
            acceptNecessaryBtn: 'Weiger alles',
            showPreferencesBtn: 'Beheer individuele voorkeuren',
            footer: '<a href="https://universalvoice.nl/privacyverklaring/" target="_blank">Privacybeleid</a>',
          },
          preferencesModal: {
            title: 'Beheer cookievoorkeuren',
            acceptAllBtn: 'Accepteer alles',
            acceptNecessaryBtn: 'Weiger alles',
            savePreferencesBtn: 'Accepteer huidige selectie',
            closeIconLabel: 'Sluit modal',
            serviceCounterLabel: 'Service|Services',
            sections: [
              {
                title: 'Uw privacykeuzes',
                description:
                  'In dit paneel kunt u enkele voorkeuren uiten met betrekking tot de verwerking van uw persoonlijke informatie.',
              },
              {
                title: 'Strikt noodzakelijk',
                description: 'Deze cookies zijn essentieel voor de goede werking van de website en kunnen niet worden uitgeschakeld.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Prestaties en analyse',
                description: 'Deze cookies verzamelen informatie over hoe u onze website gebruikt. Alle gegevens zijn geanonimiseerd en kunnen niet worden gebruikt om u te identificeren.',
                linkedCategory: 'analytics',
                cookieTable: {},
              },
            ],
          },
        },
        de: {
          consentModal: {
            title: 'Wir verwenden Cookies',
            description: '',
            acceptAllBtn: 'Alle akzeptieren',
            acceptNecessaryBtn: 'Alle ablehnen',
            showPreferencesBtn: 'Individuelle Einstellungen verwalten',
            footer: '<a href="https://universalvoice.nl/privacyverklaring/" target="_blank">Datenschutz-Bestimmungen</a>',
          },
          preferencesModal: {
            title: 'Cookie-Einstellungen verwalten',
            acceptAllBtn: 'Alle akzeptieren',
            acceptNecessaryBtn: 'Alle ablehnen',
            savePreferencesBtn: 'Aktuelle Auswahl akzeptieren',
            closeIconLabel: 'Modal schließen',
            serviceCounterLabel: 'Service|Services',
            sections: [
              {
                title: 'Ihre Datenschutzeinstellungen',
                description:
                  'In diesem Panel können Sie einige Vorlieben bezüglich der Verarbeitung Ihrer persönlichen Daten ausdrücken.',
              },
              {
                title: 'Unbedingt erforderliche',
                description: 'Diese Cookies sind für das ordnungsgemäße Funktionieren der Website unerlässlich und können nicht deaktiviert werden.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Leistung und Analyse',
                description: 'Diese Cookies sammeln Informationen darüber, wie Sie unsere Website nutzen. Alle Daten sind anonymisiert und können nicht zur Identifizierung verwendet werden.',
                linkedCategory: 'analytics',
                cookieTable: {},
              },
            ],
          },
        },
      },
    },
  } as const;

  onMount(() => {
    run(config as any);
  });
</script>

{#if showButton}
  <button class="text-xs text-primary-500 hover:text-primary-400 underline" onclick={showPreferences}>
    Cookie preferences
  </button>
{/if}
